import { app } from "../config/firebase";
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from "firebase/functions";

const functions = getFunctions(app);

if (process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === "true") {
  connectFunctionsEmulator(functions, "localhost", 5001);
}



export function functionSendPasswordResetEmail(email) {
  return new Promise(async function (resolve, reject) {
    const sendPasswordResetLinkEmail = httpsCallable(
      functions,
      "sendPasswordResetLinkEmail"
    );
    sendPasswordResetLinkEmail({ email })
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionCreateNewUser(data) {
  return new Promise(async function (resolve, reject) {
    const createNewUser = httpsCallable(functions, "createNewUser");
    createNewUser(data)
      .then((result) => {
        const data = result.data;
        console.log("createNewUser: RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionUpdateUser(data) {
  return new Promise(async function (resolve, reject) {
    const updateUser = httpsCallable(functions, "updateUser");
    updateUser(data)
      .then((result) => {
        const data = result.data;
        console.log("updateUser: RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionCreateUsersFromCsv(data) {
  return new Promise(async function (resolve, reject) {
    const createUsersFromCsv = httpsCallable(functions, "createUsersFromCsv");
    createUsersFromCsv(data)
      .then((result) => {
        const data = result.data;
        console.log("createUsersFromCsv: RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// Temporary admin tool - see seedMortgageRatesFromCsv in functions/index.js
// and MortgageRatesCsvUpload.jsx. Delete both once the historical backfill
// is done.
export function functionSeedMortgageRatesFromCsv(data) {
  return new Promise(async function (resolve, reject) {
    const seedMortgageRatesFromCsv = httpsCallable(functions, "seedMortgageRatesFromCsv");
    seedMortgageRatesFromCsv(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// Admin-only ops tool (not temporary - see FhfaHpiAdminPanel.jsx). Triggers
// the same fetch/normalize/upsert cycle the monthly updateFhfaHpiData
// scheduled function runs (functions/index.js), for the initial backfill or
// to verify/backfill on demand.
export function functionBackfillFhfaHpiDataAdmin(data) {
  return new Promise(async function (resolve, reject) {
    const backfillFhfaHpiDataAdmin = httpsCallable(functions, "backfillFhfaHpiDataAdmin");
    backfillFhfaHpiDataAdmin(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionUploadPdfFromUrl(data) {
  return new Promise(async function (resolve, reject) {
    const uploadPdfFromUrl = httpsCallable(functions, "uploadPdfFromUrl");
    uploadPdfFromUrl(data)
      .then((result) => {
        const responseData = result.data;
        console.log("uploadPdfFromUrl: RETURNED DATA: ", responseData);
        resolve(responseData);
      })
      .catch((error) => {
        console.error("uploadPdfFromUrl: ERROR: ", error);
        reject(error);
      });
  });
}

export function functionLinkUserToParty(data) {
  return new Promise(async function (resolve, reject) {
    const linkUserToParty = httpsCallable(functions, "linkUserToParty");
    linkUserToParty(data)
      .then((result) => {
        const data = result.data;
        // console.log("LinkUserToParty: RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionLinkTcUserToParty(data) {
  return new Promise(async function (resolve, reject) {
    const linkTcUserToParty = httpsCallable(functions, "linkTcUserToParty");
    linkTcUserToParty(data)
      .then((result) => {
        const data = result.data;
        // console.log("LinkTcUserToParty: RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionAddAgentAsTcToTransaction(data) {
  return new Promise(async function (resolve, reject) {
    const addAgentAsTcToTransaction = httpsCallable(
      functions,
      "addAgentAsTcToTransaction"
    );
    addAgentAsTcToTransaction(data)
      .then((result) => {
        const data = result.data;
        console.log("addAgentAsTcToXact RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionAddTcIdToTransaction(data) {
  return new Promise(async function (resolve, reject) {
    const addTcIdToTransaction = httpsCallable(
      functions,
      "addTcIdToTransaction"
    );
    addTcIdToTransaction(data)
      .then((result) => {
        const data = result.data;
        console.log("addTcIdToXact RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionAddCoAgentIdToTransaction(data) {
  return new Promise(async function (resolve, reject) {
    const addCoAgentIdToTransaction = httpsCallable(
      functions,
      "addCoAgentIdToTransaction"
    );
    addCoAgentIdToTransaction(data)
      .then((result) => {
        const data = result.data;
        //console.log("addCoAgentIdToXact RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionRemoveAgentAsTcFromTransaction(data) {
  return new Promise(async function (resolve, reject) {
    const removeAgentAsTcFromTransaction = httpsCallable(
      functions,
      "removeAgentAsTcFromTransaction"
    );
    removeAgentAsTcFromTransaction(data)
      .then((result) => {
        const data = result.data;
        console.log("removeAgentAsTc RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionRemoveTcIdFromTransaction(data) {
  return new Promise(async function (resolve, reject) {
    const removeTcIdFromTransaction = httpsCallable(
      functions,
      "removeTcIdFromTransaction"
    );
    removeTcIdFromTransaction(data)
      .then((result) => {
        const data = result.data;
        console.log("RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionRemoveCoAgentIdFromTransaction(data) {
  return new Promise(async function (resolve, reject) {
    const removeCoAgentIdFromTransaction = httpsCallable(
      functions,
      "removeCoAgentIdFromTransaction"
    );
    removeCoAgentIdFromTransaction(data)
      .then((result) => {
        const data = result.data;
        console.log("RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionShareWithAgent(data) {
  return new Promise(async function (resolve, reject) {
    const shareWithAgent = httpsCallable(functions, "shareWithAgent");
    shareWithAgent(data)
      .then((result) => {
        const data = result.data;
        // console.log("RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionShareTaskWithAgent(data) {
  return new Promise(async function (resolve, reject) {
    const shareTaskWithAgent = httpsCallable(functions, "shareTaskWithAgent");
    console.log("TASK: ", data);
    shareTaskWithAgent(data)
      .then((result) => {
        const data = result.data;
        console.log("RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionLinkTransactionWithAgent(data) {
  return new Promise(async function (resolve, reject) {
    const linkTransactionWithAgent = httpsCallable(
      functions,
      "linkTransactionWithAgent"
    );
    linkTransactionWithAgent(data)
      .then((result) => {
        const data = result.data;
        console.log("RETURNED DATA: ", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionViewAuthClaimRole(data) {
  return new Promise(async function (resolve, reject) {
    const viewAuthClaimRole = httpsCallable(functions, "viewAuthClaimRole");
    viewAuthClaimRole(data)
      .then((result) => {
        const data = result.data;
        console.log("functionViewAuthClaimRole::", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionAddAuthClaimRole(data) {
  return new Promise(async function (resolve, reject) {
    const addAuthClaimRole = httpsCallable(functions, "addAuthClaimRole");
    addAuthClaimRole(data)
      .then((result) => {
        const data = result.data;
        console.log("functionAddAuthClaimRole::", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionAddAuthClaimAssistant(data) {
  return new Promise(async function (resolve, reject) {
    const addAuthClaimAssistant = httpsCallable(
      functions,
      "addAuthClaimAssistant"
    );
    addAuthClaimAssistant(data)
      .then((result) => {
        const data = result.data;
        console.log(result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionDelAuthClaimAssistant(data) {
  return new Promise(async function (resolve, reject) {
    const delAuthClaimAssistant = httpsCallable(
      functions,
      "delAuthClaimAssistant"
    );
    delAuthClaimAssistant(data)
      .then((result) => {
        const data = result.data;
        console.log(result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionViewAllUsersWithCustomClaims() {
  return new Promise(async function (resolve, reject) {
    const viewAllUsersWithCustomClaims = httpsCallable(
      functions,
      "viewAllUsersWithCustomClaims"
    );
    viewAllUsersWithCustomClaims()
      .then((result) => {
        const data = result.data;
        console.log(result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionUpdateUserEmail(data) {
  return new Promise(async function (resolve, reject) {
    const updateUserEmail = httpsCallable(functions, "updateUserEmail");
    updateUserEmail(data)
      .then((result) => {
        const data = result.data.tokenResult;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionImpersonateUser(data) {
  return new Promise(async function (resolve, reject) {
    const impersonateUser = httpsCallable(functions, "impersonateUser");
    impersonateUser(data)
      .then((result) => {
        const data = result.data.tokenResult;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionClientLogin(creds) {
  return new Promise(async function (resolve, reject) {
    const loginClient = httpsCallable(functions, "loginClient");
    loginClient(creds)
      .then((result) => {
        const data = result.data;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionPartyLogin(email) {
  return new Promise(async function (resolve, reject) {
    const partyLogin = httpsCallable(functions, "partyLogin");
    partyLogin(email)
      .then((result) => {
        const data = result.data;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionFetchLegalAddressData(address) {
  return new Promise(async function (resolve, reject) {
    const fetchLegalAddressData = httpsCallable(
      functions,
      "fetchLegalAddressData"
    );
    fetchLegalAddressData(address)
      .then((result) => {
        const data = result.data;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function functionFetchOwnerData(address) {
  return new Promise(async function (resolve, reject) {
    const fetchOwnerData = httpsCallable(functions, "fetchOwnerData");
    fetchOwnerData(address)
      .then((result) => {
        const data = result.data;
        if (data?.[0]?.firstName) {
          data[0].firstName = toTitleCase(data[0].firstName);
        }
        if (data?.[0]?.middleName) {
          data[0].middleName = toTitleCase(data[0].middleName);
        }
        if (data?.[0]?.lastName) {
          data[0].lastName = toTitleCase(data[0].lastName);
        }
        if (data?.[1]?.firstName) {
          data[1].firstName = toTitleCase(data[1].firstName);
        }
        if (data?.[1]?.middleName) {
          data[1].middleName = toTitleCase(data[1].middleName);
        }
        if (data?.[1]?.lastName) {
          data[1].lastName = toTitleCase(data[1].lastName);
        }

        if (data?.[0]?.entityName) {
          data[0].isTrust = true;
        } else {
          data[0].isTrust = false;
        }
        if (data?.[1]?.entityName) {
          data[1].isTrust = true;
        } else {
          data[1].isTrust = false;
        }

        resolve(data);
      })
      .catch((error) => {
        console.log("error fetchOwnerData:: ", error.message);
        reject(error);
      });
  });
}

export function functionFetchMlsIres(mlsId) {
  return new Promise(async function (resolve, reject) {
    const fetchMlsIres = httpsCallable(functions, "fetchMlsIres");
    fetchMlsIres(mlsId)
      .then((result) => {
        const data = result.data;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionFetchMlsCoCren(mlsId) {
  return new Promise(async function (resolve, reject) {
    const fetchMlsCoCren = httpsCallable(functions, "fetchMlsCoCren");
    fetchMlsCoCren(mlsId)
      .then((result) => {
        const data = result.data;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionFetchMlsDataFiniti(mlsId) {
  return new Promise(async function (resolve, reject) {
    const fetchMlsDataFiniti = httpsCallable(functions, "fetchMlsDataFiniti");
    fetchMlsDataFiniti(mlsId)
      .then((result) => {
        const data = result.data;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionFetchViewsFromDataFiniti() {
  return new Promise(async function (resolve, reject) {
    const fetchViewsFromDataFiniti = httpsCallable(
      functions,
      "fetchViewsFromDataFiniti"
    );
    fetchViewsFromDataFiniti()
      .then((result) => {
        const data = result.data;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionCreateViewInDataFiniti() {
  return new Promise(async function (resolve, reject) {
    const createViewInDataFiniti = httpsCallable(
      functions,
      "createViewInDataFiniti"
    );
    createViewInDataFiniti()
      .then((result) => {
        const data = result.data;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionGetDeadlinesFromPdf(docRef) {
  return new Promise(async function (resolve, reject) {
    const getDeadlinesFromPdf = httpsCallable(functions, "getDeadlinesFromPdf");
    getDeadlinesFromPdf(docRef)
      .then((result) => {
        const data = result.data;
        resolve(data);
      })
      .catch((error) => {
        throw error;
      });
  });
}

export function functionDeleteTransaction(transactionId) {
  return new Promise(async function (resolve, reject) {
    const deleteTransaction = httpsCallable(functions, "deleteTransaction");
    deleteTransaction(transactionId)
      .then((result) => {
        const data = result.data;
        resolve(data);
      })
      .catch((error) => {
        throw error;
      });
  });
}

export function functionAddAuthClaimManagerAssistant(data) {
  return new Promise(async function (resolve, reject) {
    const addAuthClaimManagerAssistant = httpsCallable(
      functions,
      "addAuthClaimManagerAssistant"
    );
    addAuthClaimManagerAssistant(data)
      .then((result) => {
        const data = result.data;
        console.log("functionAddAuthClaimManagerAssistant::", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionGeneratePricingStrategy(data) {
  return new Promise(async function (resolve, reject) {
    // Custom (longer) client-side timeout: the Firebase JS SDK's httpsCallable
    // default (70s) is shorter than the server's functions.runWith({ timeoutSeconds: 150 }),
    // so without this the client could give up and surface a "failure" while
    // the server was still legitimately working - mirrors the same fix
    // already applied to functionGenerateListingDescriptionStrategy below.
    // Must stay ABOVE the server's 150s runWith ceiling (the relationship
    // was previously backwards at 140s < 150s) - 165s leaves ~15s of margin
    // for the server's own internal GENERATION_DEADLINE_MS=125s +
    // FINALIZATION_RESERVE_MS=20s budget (see aiReliability/requestDeadline.js)
    // to finish and respond before the client would give up on its own.
    const generatePricingStrategy = httpsCallable(
      functions,
      "generatePricingStrategy",
      { timeout: 165000 }
    );
    generatePricingStrategy(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionResearchPropertyListing(data) {
  return new Promise(async function (resolve, reject) {
    const researchPropertyListing = httpsCallable(
      functions,
      "researchPropertyListing"
    );
    researchPropertyListing(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionFetchSubjectPropertyFromDataFiniti(data) {
  return new Promise(async function (resolve, reject) {
    const fetchSubjectPropertyFromDataFiniti = httpsCallable(
      functions,
      "fetchSubjectPropertyFromDataFiniti"
    );
    fetchSubjectPropertyFromDataFiniti(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionFetchComparableSalesFromDataFiniti(data) {
  return new Promise(async function (resolve, reject) {
    const fetchComparableSalesFromDataFiniti = httpsCallable(
      functions,
      "fetchComparableSalesFromDataFiniti"
    );
    fetchComparableSalesFromDataFiniti(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionDelAuthClaimManagerAssistant(data) {
  return new Promise(async function (resolve, reject) {
    const delAuthClaimManagerAssistant = httpsCallable(
      functions,
      "delAuthClaimManagerAssistant"
    );
    delAuthClaimManagerAssistant(data)
      .then((result) => {
        const data = result.data;
        console.log("functionDelAuthClaimManagerAssistant::", result.data);
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//////////////////////////////////////////////////////////////////////////
////////////  INTELLIGENT STRATEGIES: CREDITS & ENTITLEMENT  //////////////
//////////////////////////////////////////////////////////////////////////

export function functionGetStrategyEntitlement(data) {
  return new Promise(async function (resolve, reject) {
    const getStrategyEntitlement = httpsCallable(functions, "getStrategyEntitlement");
    getStrategyEntitlement(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionUnlockStrategyProperty(data) {
  return new Promise(async function (resolve, reject) {
    const unlockStrategyProperty = httpsCallable(functions, "unlockStrategyProperty");
    unlockStrategyProperty(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionSubmitStrategyFeedback(data) {
  return new Promise(async function (resolve, reject) {
    const submitStrategyFeedback = httpsCallable(functions, "submitStrategyFeedback");
    submitStrategyFeedback(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionGetStrategyFeedbackState(data) {
  return new Promise(async function (resolve, reject) {
    const getStrategyFeedbackState = httpsCallable(functions, "getStrategyFeedbackState");
    getStrategyFeedbackState(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionGetStrategyCreditProducts() {
  return new Promise(async function (resolve, reject) {
    const getStrategyCreditProducts = httpsCallable(functions, "getStrategyCreditProducts");
    getStrategyCreditProducts()
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionCreateStrategyCreditCheckout(data) {
  return new Promise(async function (resolve, reject) {
    const createStrategyCreditCheckout = httpsCallable(functions, "createStrategyCreditCheckout");
    createStrategyCreditCheckout(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionGetManagerStrategyCreditProducts() {
  return new Promise(async function (resolve, reject) {
    const getManagerStrategyCreditProducts = httpsCallable(functions, "getManagerStrategyCreditProducts");
    getManagerStrategyCreditProducts()
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionCreateManagerStrategyCreditCheckout(data) {
  return new Promise(async function (resolve, reject) {
    const createManagerStrategyCreditCheckout = httpsCallable(functions, "createManagerStrategyCreditCheckout");
    createManagerStrategyCreditCheckout(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionGetGlobalStrategySettings() {
  return new Promise(async function (resolve, reject) {
    const getGlobalStrategySettingsCallable = httpsCallable(functions, "getGlobalStrategySettingsCallable");
    getGlobalStrategySettingsCallable()
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionAdminUpdateGlobalStrategySettings(data) {
  return new Promise(async function (resolve, reject) {
    const adminUpdateGlobalStrategySettings = httpsCallable(functions, "adminUpdateGlobalStrategySettings");
    adminUpdateGlobalStrategySettings(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionAdminGrantStrategyCredits(data) {
  return new Promise(async function (resolve, reject) {
    const adminGrantStrategyCredits = httpsCallable(functions, "adminGrantStrategyCredits");
    adminGrantStrategyCredits(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionAdminGrantManagerPoolCredits(data) {
  return new Promise(async function (resolve, reject) {
    const adminGrantManagerPoolCredits = httpsCallable(functions, "adminGrantManagerPoolCredits");
    adminGrantManagerPoolCredits(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionAdminGetUserStrategyCredits(data) {
  return new Promise(async function (resolve, reject) {
    const adminGetUserStrategyCredits = httpsCallable(functions, "adminGetUserStrategyCredits");
    adminGetUserStrategyCredits(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionAdminSetUserFeedbackCreditOverride(data) {
  return new Promise(async function (resolve, reject) {
    const adminSetUserFeedbackCreditOverride = httpsCallable(functions, "adminSetUserFeedbackCreditOverride");
    adminSetUserFeedbackCreditOverride(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionAdminGetManagerPoolStrategyCredits(data) {
  return new Promise(async function (resolve, reject) {
    const adminGetManagerPoolStrategyCredits = httpsCallable(functions, "adminGetManagerPoolStrategyCredits");
    adminGetManagerPoolStrategyCredits(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionAdminBackfillPaidAgentStrategyCredits(data) {
  return new Promise(async function (resolve, reject) {
    const adminBackfillPaidAgentStrategyCredits = httpsCallable(functions, "adminBackfillPaidAgentStrategyCredits");
    adminBackfillPaidAgentStrategyCredits(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionGetManagerStrategyCreditsOverview() {
  return new Promise(async function (resolve, reject) {
    const getManagerStrategyCreditsOverview = httpsCallable(functions, "getManagerStrategyCreditsOverview");
    getManagerStrategyCreditsOverview()
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionUpdateManagerSharingSettings(data) {
  return new Promise(async function (resolve, reject) {
    const updateManagerSharingSettingsCallable = httpsCallable(functions, "updateManagerSharingSettingsCallable");
    updateManagerSharingSettingsCallable(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionGetStrategyGenerationResult(data) {
  return new Promise(async function (resolve, reject) {
    const getStrategyGenerationResult = httpsCallable(functions, "getStrategyGenerationResult");
    getStrategyGenerationResult(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionGetStrategyPropertiesForTransaction(data) {
  return new Promise(async function (resolve, reject) {
    const getStrategyPropertiesForTransaction = httpsCallable(functions, "getStrategyPropertiesForTransaction");
    getStrategyPropertiesForTransaction(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

//////////////////////////////////////////////////////////////////////////
////////////////////  LISTING DESCRIPTION STRATEGY  ///////////////////////
//////////////////////////////////////////////////////////////////////////

export function functionGenerateListingDescriptionStrategy(data) {
  return new Promise(async function (resolve, reject) {
    // Custom (longer) client-side timeout: the Firebase JS SDK's httpsCallable
    // defaults to 70s, but this callable does research + generation + a
    // possible corrective compliance pass sequentially in one call (matches
    // the server's functions.runWith({ timeoutSeconds: 300 }) in
    // functions/index.js) - the default 70s was cutting it off client-side
    // with a "deadline-exceeded" error well before the server itself timed out.
    const generateListingDescriptionStrategy = httpsCallable(functions, "generateListingDescriptionStrategy", { timeout: 290000 });
    generateListingDescriptionStrategy(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionGetStrategyGenerationsForProperty(data) {
  return new Promise(async function (resolve, reject) {
    const getStrategyGenerationsForProperty = httpsCallable(functions, "getStrategyGenerationsForProperty");
    getStrategyGenerationsForProperty(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionUpdateListingDescriptionFactDecision(data) {
  return new Promise(async function (resolve, reject) {
    const updateListingDescriptionFactDecision = httpsCallable(functions, "updateListingDescriptionFactDecision");
    updateListingDescriptionFactDecision(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionSelectListingDescriptionVersion(data) {
  return new Promise(async function (resolve, reject) {
    const selectListingDescriptionVersion = httpsCallable(functions, "selectListingDescriptionVersion");
    selectListingDescriptionVersion(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

export function functionUpdateListingDescriptionEdits(data) {
  return new Promise(async function (resolve, reject) {
    const updateListingDescriptionEdits = httpsCallable(functions, "updateListingDescriptionEdits");
    updateListingDescriptionEdits(data)
      .then((result) => resolve(result.data))
      .catch((error) => reject(error));
  });
}

// Transaction notification emails - moved server-side (see functions/index.js)
// because resolving recipients requires reading OTHER users' profile docs,
// which the caller (agent, manager, or a signed-in party) doesn't always have
// Firestore permission to do directly.
export function functionSendNewTransactionNotificationEmail(data) {
  return new Promise(async function (resolve, reject) {
    const sendNewTransactionNotificationEmail = httpsCallable(
      functions,
      "sendNewTransactionNotificationEmail"
    );
    sendNewTransactionNotificationEmail(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionSendDocumentSignedNotificationEmails(data) {
  return new Promise(async function (resolve, reject) {
    const sendDocumentSignedNotificationEmails = httpsCallable(
      functions,
      "sendDocumentSignedNotificationEmails"
    );
    sendDocumentSignedNotificationEmails(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function functionSendTransactionStatusChangedNotificationEmails(data) {
  return new Promise(async function (resolve, reject) {
    const sendTransactionStatusChangedNotificationEmails = httpsCallable(
      functions,
      "sendTransactionStatusChangedNotificationEmails"
    );
    sendTransactionStatusChangedNotificationEmails(data)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// ---- Property Intelligence (functions/propertyIntelligence) ----------------
// Research runs as a durable server-side job; these calls only start it,
// read its saved state, and change saved data - none of them performs
// external research except the one-time startPropertyIntelligence.
function callPropertyIntelligence(name, data, options) {
  const callable = httpsCallable(functions, name, options);
  return callable(data).then((result) => result.data);
}

export function functionGetPropertyIntelligence(data) {
  return callPropertyIntelligence("getPropertyIntelligence", data);
}

export function functionStartPropertyIntelligence(data) {
  return callPropertyIntelligence("startPropertyIntelligence", data);
}

export function functionResumePropertyIntelligence(data) {
  return callPropertyIntelligence("resumePropertyIntelligence", data);
}

export function functionUpdatePropertyIntelligenceReport(data) {
  return callPropertyIntelligence("updatePropertyIntelligenceReport", data);
}

export function functionSavePropertyIntelligenceClientSummary(data) {
  return callPropertyIntelligence("savePropertyIntelligenceClientSummary", data);
}

export function functionCreatePropertyIntelligencePdf(data) {
  return callPropertyIntelligence("createPropertyIntelligencePdf", data, { timeout: 130000 });
}

export function functionVerifyPropertyIntelligenceSharing(data) {
  return callPropertyIntelligence("verifyPropertyIntelligenceSharing", data);
}
